import { inject } from '@angular/core';
import { AuthApiService } from '@core/services/api/auth.service';
import { AuthStateService } from '@shared/services/auth-state.service';
import { TokenRefreshService } from '@shared/services/token-refresh.service';
import { catchError, firstValueFrom, of } from 'rxjs';

/**
 * Inicializador de autenticación que se ejecuta antes de cargar la aplicación.
 * Intenta restaurar la sesión del usuario usando el refresh token almacenado en cookies.
 * Si el refresh falla o no hay cookie, la app carga sin sesión.
 */
export function authInitializer() {
  const authState = inject(AuthStateService);
  const authApi = inject(AuthApiService);
  // Forzar instanciación del TokenRefreshService para que su sincronización
  // entre pestañas esté activa en el panel.
  inject(TokenRefreshService);

  // Siempre intentar restaurar la sesión si hay refresh token en cookies
  return firstValueFrom(authApi.refresh().pipe(catchError(() => of(null)))).then((rs) => {
    if (rs && rs.access_token) {
      authState.setSession(rs);
    } else {
      console.warn('Auth initializer: No hay sesión previa');
    }
    authState.setAuthReady(true);
  });
}
